import { render, staticRenderFns } from "./BrowseBuildingIken.vue?vue&type=template&id=2e608998&scoped=true&"
import script from "./BrowseBuildingIken.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingIken.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingIken.vue?vue&type=style&index=0&id=2e608998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e608998",
  null
  
)

export default component.exports